/*RollupButtonContainer */
import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import * as S from './CheckoutRollup.styles';

export function RollupButtonContainer({ children }: PropsWithChildren) {
  const buttonContainerRef = useRef<HTMLDivElement | null>(null);
  const [containerPosition, setContainerPosition] = useState<number>(0);

  useEffect(() => {
    const buttonContainer = buttonContainerRef.current;
    const footer = document.querySelector('footer');

    const handleScroll = () => {
      if (buttonContainer && footer) {
        const distanceToFooter =
          footer.getBoundingClientRect().top -
          buttonContainer.getBoundingClientRect().bottom;
        if (distanceToFooter < 4) {
          setContainerPosition(footer.offsetHeight);
        } else {
          setContainerPosition(0);
        }
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <S.RollupButtonContainer
      ref={buttonContainerRef}
      $containerPosition={containerPosition}
    >
      {children}
    </S.RollupButtonContainer>
  );
}
/* */
